exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-footer__buttons[data-v-d26b5aba] {\r\n  padding: 0.8rem 0.4rem;\n}\n.van-footer__buttons .van-button[data-v-d26b5aba] {\r\n  margin-bottom: 0.4rem;\n}\r\n", ""]);

// exports
